<template>
  <a-config-provider :locale="locale" :theme="theme" :tag="tag">
    <a-app>
      <template #renderEmpty>
        <div style="text-align: center">
          <!-- <SmileOutlined style="font-size: 20px" /> -->
          <p>暂无数据</p>
        </div>
      </template>
      <div id="app">
        <a-watermark
          v-if="showWatermark"
          class="ndb-app-watermark"
          :content="watermarkContent"
          :font="watermarkFont"
          :gap="[160, 120]"
          :width="180"
          :height="86"
          :rotate="-24"
        >
          <a-spin :spinning="loading" style="height: 100%">
            <router-view />
          </a-spin>
        </a-watermark>
        <a-spin v-else :spinning="loading" style="height: 100%">
          <router-view />
        </a-spin>
      </div>
    </a-app>
  </a-config-provider>
</template>

<script setup>
import zhCN from "antdv-next/locale/zh_CN";
import antdTheme from "@/config/theme.js";
import { useAppStore } from "@/store/modules/app.js";
import { useUserStore } from "@/store/modules/user.js";
import { ACCESS_TOKEN } from "@/store/mutation-types.js";
import { getCookie } from "@/utils/storage.js";

const route = useRoute();
const appStore = useAppStore();
const userStore = useUserStore();

const locale = zhCN;
const theme = antdTheme;
const tag = {
  variant: "solid"
};
const watermarkFont = {
  color: "rgba(29, 29, 31, 0.08)",
  fontSize: 14,
  fontWeight: 600,
  fontFamily:
    "Inter, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif"
};

const loading = computed(() => appStore.loading);
const currentUser = computed(() => userStore.userInfo || {});
const isLoggedIn = computed(() =>
  Boolean(userStore.token || currentUser.value.id || getCookie(ACCESS_TOKEN))
);
const showWatermark = computed(() => isLoggedIn.value && route.path !== "/users/sign_in");
const watermarkContent = computed(() => {
  const userName = currentUser.value.name_en || currentUser.value.name_cn || "NDB";
  const email = currentUser.value.email || currentUser.value.username || "";
  return email ? [userName, email] : userName;
});
</script>

<style scoped lang="less">
.ndb-app-watermark {
  min-height: 100%;
  overflow: visible;
}
</style>
